<template>
    <!-- ポップを出す時の修正ポイント① html、css部分を適宜 -->
    <BaseDialog
        width="640px"
        :visible="visible"
        title="利用規約変更のお知らせ"
        :submitBtn="false"
        cancelText="閉じる"
        :onCancel="onCancel"
        :closeOnClickOutside="false"
        destroy-on-close
        @submit="consent"
    >
        <div class="container">
            <!-- <div class="img">
                <img src="/png/campaign-7th-anniversary.png" alt="Aerial Partners ７周年キャンペーン実施中！" />
            </div> -->

            <div style="font-size: 1.6rem">
                <p>2025年5月1日、利用規約を一部改定いたしましたことをお知らせします。</p>
                <p>
                    詳細は<a href="https://crypto-city.net/media/20250422" target="_blank">こちらのページ</a
                    >をご確認ください。
                </p>
            </div>
        </div>
    </BaseDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { clientStorage, STORAGE_KEYS } from '@/libs/storage.js';
import { isBefore, toDate } from '@/libs/date.js';
import BaseDialog from '../BaseDialog.vue';

// ポップを出す時の修正ポイント②
// STORAGE_KEYSのファイルに飛んでinitailPopのkeyを変更する。（他と被らないよう日付を入れると良い）
// 変更前のkeyはdeprecatedKeysに追加しておく。
const KEY = STORAGE_KEYS.initialPop;

// ポップを出す時の修正ポイント③ 了解しました的なボタンを押さない限り毎回出るようにしたい場合、trueにする。
const forceAgreement = false;

export default {
    components: { BaseDialog },
    data() {
        return {
            isClosed: false,
            forceAgreement,
        };
    },
    computed: {
        ...mapGetters(['getCurrentUser']),

        // ポップを出す時の修正ポイント④ 期間、対象ユーザーなどポップが出る条件を入れる
        enabled() {
            const isUserBeforeUpdate = isBefore(this.getCurrentUser.created_at, toDate('2025-05-01'));
            return isUserBeforeUpdate;
        },

        visible() {
            if (!this.enabled || this.isClosed) return false;
            // E2Eテスト時は表示しない
            if (this.$config.appEnv === 'testing') return false;
            return clientStorage.get(KEY) !== 'true';
        },
    },
    methods: {
        consent() {
            clientStorage.set(KEY, 'true');
            this.isClosed = true;
        },
        onCancel() {
            if (!this.forceAgreement) this.consent();
            else this.isClosed = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.img {
    width: 100%;
    aspect-ratio: 2;
}
</style>
